import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {__} from "~/ts/library/Translate";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OPERATOR_APPLICATION_SOUND_TARGET_CLIENT} from "~/operatorApplication/ts/service/OperatorApplicationSoundPlayer";

export default class NewTargetClient extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "newTargetClient";
    }

    public async receive(payload: CometOperatorApplication.NewTargetClientCometMessageOpenApiModel) {
        if (OperatorApplicationConfigInstance.targetClientNotificationsEnabled) {
            OPERATOR_APPLICATION_SOUND_TARGET_CLIENT.play(true);
            OperatorApplicationPlatform.notifications.show({
                title: __("Целевой посетитель на %s", payload.siteDescr),
                text: payload.why.join("\n"),
                click: () => {
                    let username = payload.username;
                    OperatorApplicationBuddyList.addClientAndOpenByUsername(username);
                }
            });
        }
    }

}